import {StyleSheet} from 'aphrodite';

const styles = StyleSheet.create({
    noServiceMessage: {
        textAlign: 'center'
    }
});

export default styles;
